import { secondDatabase } from "../../config/firebase";

const writeBuildProjectId = async (selectedProject, projectId) => {

  try {
    const dbPath = `${selectedProject.firmDetailsID}/projectsUserDetails/${selectedProject.projectID}`;

    const dbRef = secondDatabase.ref(dbPath);
    const snapshot = await dbRef.once("value");

    if (snapshot.exists()) {

      const projectUsers = snapshot.val();
      const addedIds = Object.keys(projectUsers);

      const updatePromises = addedIds.map((userId) => {
        const updatePath = `userDetails/${userId}/projects/${selectedProject.projectID}/buildProjectId`;
        console.log(`Updating path: ${updatePath}`);
        return secondDatabase.ref(updatePath).set(Number(projectId));
      });

      await Promise.all(updatePromises);
    } else {
      console.warn("No data found at the specified path.");
    }
  } catch (error) {
    console.error("Error writing build project ID:", error);
  }
};

export default writeBuildProjectId;
